import VirtualControlPad, {padButtons} from "../managers/VirtualControlPad";
import { gameArea } from "../utils/gameArea";
import DigitalWarrior, { WarriorActions, WarriorStates, AttackCircle } from "../sprites/DigitalWarrior";
import game from "../game";
import DigitalWarriorAI from "../managers/enemyAI/DigitalWarriorAI";
import HUDScene from "./HUDScene";
import ChargePickup, { ChargePickupState } from "../sprites/pickups/ChargePickup";
import PauseDeathScene, { PauseDeathModes } from "./PauseDeathScene";
import SoundManager from "../managers/SoundManager";
import CyberShooter from "../sprites/CyberShooter";
import BaseCombatant from "../sprites/BaseCombatant";
import EnergyBall, { EnergyBallStates } from "../sprites/EnergyBall";
import CyberShooterAI from "../managers/enemyAI/CyberShooterAI";
import EnergyBallMachine from "../sprites/EnergyBallMachine";
import EnergyBallMachineAI from "../managers/enemyAI/EnergyBallMachineAI";
import TextBlurbScene, { TextBlurbStates } from "./TextBlurbScene";

export enum GameModes {
  INIT = 0,
  COUNTIN = 1,
  FIGHT = 2,
  PAUSED = 3,
  FIGHTEND = 4
}

export default class GameScene extends Phaser.Scene {
  gameMode: GameModes;
  map: Phaser.Tilemaps.Tilemap;
  tileset: Phaser.Tilemaps.Tileset;
  player: DigitalWarrior;
  CRTPipeline: any;
  HUD: HUDScene;
  chargePickups: Phaser.Physics.Arcade.Group;
  countInText: Phaser.GameObjects.Text;
  opponents: Phaser.Physics.Arcade.Group;
  currentArena: number;
  currentArenaFight: number;
  energyBalls: Phaser.Physics.Arcade.Group;
  attackCircles: Phaser.Physics.Arcade.Group;
  fightList: string[];
  forcefield: Phaser.Tilemaps.StaticTilemapLayer;
  walls: Phaser.Tilemaps.StaticTilemapLayer;

  constructor() {
    super({ key: 'GameScene' });
    this.currentArena = 1;
    this.currentArenaFight = 0;
  }

  preload(){
    const renderer = < Phaser.Renderer.WebGL.WebGLRenderer>game.renderer;
    this.CRTPipeline = renderer.getPipeline('CRT');
    this.load.tilemapTiledJSON('arena1', './assets/tiles/arena1.json');
  }

  create() {

    this.cameras.main.setRenderToTexture(this.CRTPipeline);
    this.cameras.main.setBackgroundColor("#2e0040");
    this.cameras.main.setBounds(0, 0, 1920 * gameArea.scale, 1080 * gameArea.scale);
    this.physics.world.setBounds(0, 0, 1920 * gameArea.scale, 1080 * gameArea.scale);
    
    this.map = this.make.tilemap({key:'arena1'});
    this.tileset = this.map.addTilesetImage('ArenaFuturaMaptiles', 'arenaTiles',8,8,1,2);

    this.fightList= ['fight1','fight2','fight3','fight4','fight5','boss1'];

    const floor = this.map.createStaticLayer('arenaFloor', this.tileset,gameArea.offset.x,gameArea.offset.y);
    floor.setScale(gameArea.scale);
    floor.setDepth(0);

    this.walls = this.map.createStaticLayer('arenaWalls', this.tileset,gameArea.offset.x,gameArea.offset.y);
    this.walls.setScale(gameArea.scale);
    this.walls.setCollisionByExclusion([-1], true);
    this.walls.setDepth(1);

    this.forcefield = this.map.createStaticLayer('arenaForceField', this.tileset,gameArea.offset.x,gameArea.offset.y);
    this.forcefield.setScale(gameArea.scale);
    this.forcefield.setCollisionByExclusion([-1], true);
    this.forcefield.setDepth(1);
    this.forcefield.setAlpha(0.8);
    this.forcefield.setBlendMode(Phaser.BlendModes.ADD);

    this.chargePickups = this.physics.add.group({
      classType: ChargePickup
    });

    this.opponents = this.physics.add.group({
      classType: DigitalWarrior
    });

    this.energyBalls = this.physics.add.group({
      classType: EnergyBall
    })

    this.attackCircles = this.physics.add.group({
      classType: AttackCircle
    })

    this.player = new DigitalWarrior(this,0,0,"player","pinkManSpriteSheet");

    this.physics.add.collider(this.player, this.walls);
    this.physics.add.collider(this.opponents, this.walls);
    this.physics.add.collider(this.player, this.opponents);
    this.physics.add.collider(this.player, this.forcefield);

    this.physics.add.collider(this.energyBalls, this.walls);
    this.physics.add.overlap(this.player,this.energyBalls,this.energyBallCallback.bind(this));
    this.physics.add.overlap(this.opponents,this.energyBalls,this.energyBallCallback.bind(this));

    this.physics.add.overlap(this.player,this.attackCircles,this.DigitalWarriorHitCallBack.bind(this));
    this.physics.add.overlap(this.opponents,this.attackCircles,this.DigitalWarriorHitCallBack.bind(this));
    this.physics.add.collider(this.attackCircles,this.energyBalls,this.energyBallAttackCircleCallback.bind(this));

    this.physics.add.overlap(this.player,this.chargePickups,this.chargeHitCallback.bind(this));
    this.physics.add.overlap(this.opponents,this.chargePickups,this.chargeHitCallback.bind(this));

    const ceiling = this.map.createStaticLayer('arenaCeiling', this.tileset,gameArea.offset.x,gameArea.offset.y);
    ceiling.setScale(gameArea.scale);
    ceiling.setDepth(4);

    this.HUD = <HUDScene>this.scene.get('HUDScene');
    
  }

  energyBallAttackCircleCallback(circle: AttackCircle, ball: EnergyBall){
    if(circle.parent === this.player){
      ball.setState(EnergyBallStates.friendly);
    }
  }

  energyBallCallback(target: BaseCombatant,ball: EnergyBall){
    if(
      target.canBeHit() &&
      (
        (target.name === "blueOpponent") ||
        (target.name === "cyberShooter" && ball.state === EnergyBallStates.friendly) ||
        (target.name === "energyBallMachine" && ball.state === EnergyBallStates.friendly) ||
        (target.name === "player" && ball.state === EnergyBallStates.hostile)
      )
    ){

      const angle = Phaser.Math.Angle.BetweenPoints(ball,target);
      target.takeHit(
        new Phaser.Math.Vector2(Math.cos(angle),Math.sin(angle)),
        10
      );
      ball.end();
      this.tweens.add({
        targets: this.CRTPipeline,
        intensity: {
          from: 1,
          to: 0.1
        },
        duration: 500
      })
    }else{
      return;
    }
  }

  chargeHitCallback(collector: DigitalWarrior,chargePickup: ChargePickup){
    if(chargePickup.pickupState === ChargePickupState.active){
      SoundManager.playSfx("pickup")
      chargePickup.setPickupState(ChargePickupState.inactive);
      collector.addCharge(chargePickup.chargeValue);
    }
  }

  DigitalWarriorHitCallBack(target: BaseCombatant, attackCircle: AttackCircle){
    const assailant = <DigitalWarrior>attackCircle.parent;
    if(assailant === target) return;
    if(typeof assailant === "undefined") return;
    if(!assailant.isAttacking()) return;
    if(!target.canBeHit()) return;
    const angle = Phaser.Math.Angle.BetweenPoints(assailant,target);
    target.takeHit(
      new Phaser.Math.Vector2(Math.cos(angle),Math.sin(angle)),
      10
    );
    this.tweens.add({
      targets: this.CRTPipeline,
      intensity: {
        from: 1,
        to: 0.1
      },
      duration: 500
    })
  }

  resetGame(){
    this.time.removeAllEvents();
    this.chargePickups.clear(true,true);
    this.energyBalls.clear(true,true);
    this.player.directionFacing.set(1,1);
    this.player.reset();
    this.opponents.clear(true,true);

    const placements = this.map.getObjectLayer(this.fightList[this.currentArenaFight]);


    for(const key in placements.properties){
      if (placements.properties.hasOwnProperty(key)) {
        const obj = placements.properties[key];
        switch(obj.name){
          case "forcefieldEnabled":
            if(obj.value === true){
              this.forcefield.setVisible(true);
              this.forcefield.setCollisionByExclusion([-1],true);
            }else{
              this.forcefield.setVisible(false);
              this.forcefield.setCollisionByExclusion([-1],false);
            }
          break
        }
      }
    }

    placements.objects.forEach(obj => {
      let pos = [gameArea.offset.x + (obj.x * gameArea.scale), gameArea.offset.y + (obj.y * gameArea.scale)];
      switch(obj.name){
        case "playerStart":
          this.player.setPosition(pos[0],pos[1]);
          this.player.shadow.setPosition(pos[0],pos[1]);
        break;
        case "opponentStart":
          let opponent = null;
          switch(obj.type){
            case "DigitalWarrior":
              opponent = new DigitalWarrior(this,pos[0],pos[1],"blueOpponent","blueManSpriteSheet");
              opponent.speed = 100 + Math.ceil(Math.random() * 40);
              if(opponent.brain === null) opponent.brain = new DigitalWarriorAI(this, opponent,this.player);
            break;
            case "CyberShooter":
              opponent = new CyberShooter(this,pos[0],pos[1]);
              opponent.speed = 20 + Math.ceil(Math.random() * 40);
              if(opponent.brain === null) opponent.brain = new CyberShooterAI(this, opponent,this.player);
            break;
            case "EnergyBallMachine":
              opponent = new EnergyBallMachine(this,pos[0],pos[1]);
              opponent.speed = 0;
              if(opponent.brain === null) opponent.brain = new EnergyBallMachineAI(this, opponent,this.player);
            break;
          }
          if(opponent === null) break;
          opponent.shadow.setPosition(pos[0],pos[1]);
          this.opponents.add(opponent);
          opponent.directionFacing.set(-1,1);
          opponent.reset();
        break;
        case "chargePoint":
          const cp = this.chargePickups.get(pos[0],pos[1]);
          cp.setPickupState(ChargePickupState.active);
          this.add.existing(cp);
        break;
        case "centrePoint":
          this.cameras.main.stopFollow();
          this.cameras.main.centerOn(pos[0],pos[1]);
        break;
      }
    });
  }

  setMode(newMode: GameModes){
    switch(newMode){
      case GameModes.INIT:
        this.resetGame();
        this.HUD.scene.wake();
        this.HUD.scene.bringToTop();
        this.setMode(GameModes.COUNTIN);
      break;
      case GameModes.COUNTIN:
        SoundManager.stopAllMusic();
        this.sys.canvas.style.cursor = "none";
        this.HUD.doCountIn( () => {
          this.cameras.main.pan(this.player.x,this.player.y,500,"Power2",false,(cam,progress)=>{
            if(progress === 1) this.setMode(GameModes.FIGHT);
          })
        });
      break;
      case GameModes.FIGHT:
        this.cameras.main.startFollow(this.player);
        this.sys.canvas.style.cursor = "none";
        this.HUD.scene.bringToTop();
      break;
      case GameModes.PAUSED:
        this.bringUpPauseDeathScene(PauseDeathModes.PAUSED);
        this.sys.canvas.style.cursor = "auto";
      break;
      case GameModes.FIGHTEND:
        const result = (this.player.currentState === WarriorStates.DEAD)? PauseDeathModes.LOSER : PauseDeathModes.WINNER;
        this.player.stop();
        if(this.player.currentAction === WarriorActions.MOVING) 
          this.player.setAction(WarriorActions.IDLE);
        
        this.energyBalls.clear(true,true);
        this.time.delayedCall(3000, () =>{
          this.sys.canvas.style.cursor = "auto";
          if(this.currentArenaFight === this.fightList.length - 1 && result === PauseDeathModes.WINNER){
            const endScene = <TextBlurbScene>this.scene.get("TextBlurbScene");
            endScene.setState(TextBlurbStates.ENDING);
            endScene.scene.resume();
            this.scene.sleep('HUDScene');
            endScene.scene.setVisible(true);
            endScene.scene.bringToTop();
            this.scene.sleep();
          }else{
            this.bringUpPauseDeathScene(result)
          }
        });
      break;
      default:
        this.sys.canvas.style.cursor = "auto";
      break;
    }
    this.gameMode = newMode;
  }

  bringUpPauseDeathScene(mode: PauseDeathModes){
    this.scene.pause();
    const pauseScene = <PauseDeathScene>this.scene.get('PauseEndScene');
    pauseScene.setMode(mode);
    pauseScene.scene.resume();
    pauseScene.scene.setVisible(true);
    pauseScene.scene.bringToTop();
  }

  update(time: number,delta: number){
    this.CRTPipeline.time+=delta;
    switch(this.gameMode){
      case GameModes.PAUSED:
        if(VirtualControlPad.isClicked(padButtons.START)){
          this.setMode(GameModes.FIGHT);
        }
      break;
      case GameModes.FIGHT:

        const playerDirection: Phaser.Math.Vector2 = new Phaser.Math.Vector2(0,0);
        if(VirtualControlPad.isClickedOrHeld(padButtons.LEFT)){
          playerDirection.x -= 1;
        }
        if(VirtualControlPad.isClickedOrHeld(padButtons.RIGHT)){
          playerDirection.x += 1;
        }
        if(VirtualControlPad.isClickedOrHeld(padButtons.UP)){
          playerDirection.y -= 1;
        }
        if(VirtualControlPad.isClickedOrHeld(padButtons.DOWN)){
          playerDirection.y += 1;
        }
        this.player.move(playerDirection);

        if(VirtualControlPad.isClicked(padButtons.START)){
          this.setMode(GameModes.PAUSED);
        }

        if(VirtualControlPad.isClicked(padButtons.A)){
          this.player.setAction(WarriorActions.ATTACKING);
        }
        if(VirtualControlPad.isClicked(padButtons.B)){
          this.player.setAction(WarriorActions.DEFENDING);
        }
        if(VirtualControlPad.isReleased(padButtons.B) && this.player.currentAction === WarriorActions.DEFENDING){
          this.player.setAction(WarriorActions.IDLE);
        }
        let deadOpponents = 0;
        this.opponents.getChildren().forEach( (op: DigitalWarrior) => {
          if(op.currentState === WarriorStates.DEAD) deadOpponents++; else op.update(time,delta);
        });
        if(this.player.currentState === WarriorStates.DEAD || deadOpponents === this.opponents.countActive()){
          this.setMode(GameModes.FIGHTEND);
        }

      break;
      case GameModes.COUNTIN:
      case GameModes.FIGHTEND:
        //do nowt
      break;
    }
    this.player.update(time,delta);
    this.HUD.setHealth(Math.ceil(this.player.health));
    this.HUD.setCharge(Math.ceil(this.player.attackCharge));
    this.HUD.draw();
  }

}
